import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'
import moment from 'moment'
import { BUSCAR_BI_VENDEDOR } from '../types'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarBIVendedor (idEmpresa, dataInicio, dataFim) {
    const url = `${URL}/vexado-bi/resumo?idEmpresa=${idEmpresa}` +
        `&dataInicio=${moment(dataInicio).format('YYYY-MM-DD')}` +
        `&dataFim=${moment(dataFim).format('YYYY-MM-DD')}`
    return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
        .then(response => dispatch({ type: BUSCAR_BI_VENDEDOR, payload: response.data }))
        .catch(erro => {
            if (!navigator.onLine || !erro.response) {
                return dispatch({ type: BUSCAR_BI_VENDEDOR, payload: null });
            }
            throw erro;
        })
}
